import React, { useState } from "react"
import _ from "lodash"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "fetch-everywhere"
import "./File.scss"

import { MessageBubble } from "../util"

const File = ({ data, color, isUser = false }) => {
  const [url] = useState(data.url || data.downloadUrl || _.get(data, "attachments[0].url"))
  if (url) {
    const startIndex = (url.indexOf("\\") >= 0 ? url.lastIndexOf("\\") : url.lastIndexOf("/"))
    let filename = url.substring(startIndex)
    if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
      filename = filename.substring(1)
    }

    return (
      <MessageBubble isUser={isUser} color={color} className="message-bubble file">
        <a className="file-file" href={url} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon
            className="icon"
            icon="file"
          />
          <span className="file-name">{data.filename ? data.filename : filename}</span>
        </a>
        {
          data.text || data.caption ?
            <div className="caption">{data.text || data.caption}</div>
            :
            null
        }
      </MessageBubble>
    )
  }
  return (
    <MessageBubble className="message-bubble file placeholder">
      <FontAwesomeIcon
        className="icon"
        icon="file"
      />
      <span>File cannot be loaded</span>
    </MessageBubble>
  )
  
}

export default File
